import React, { FC, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import IdleCheckModal from "../modals/IdleCheck";

// components
import QuestionnaireSubmissionForm from "../questionnaire_submission/QuestionnaireSubmissionForm";

interface Props {
  questionnaire_assignments: Array<any>;
  csrfToken: string;
  logo_src: string;
  user_id: string;
  qrId: string;
}

const TabletQuestionnaire: FC<Props> = (props: any) => {
  const [subStatus, setSubStatus] = useState<string>("submission");
  const [userId, _] = useState<string>(props.user_id);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [questionnaireAssignment, setQuestionnaireAssignment] = useState<any>(
    props.questionnaire_assignments[0]
  );
  const [questionnaireAssignments, setQuestionnaireAssignments] = useState<any>(
    props.questionnaire_assignments
  );
  const [submitTrigger, setSubmitTrigger] = useState(false);

  useEffect(() => {
    if (currentStep <= questionnaireAssignments.length) {
      setQuestionnaireAssignment(questionnaireAssignments[currentStep]);
    }
  }, [currentStep, questionnaireAssignment]);

  useEffect(() => {
    if (subStatus == "thankYou") {
      fetch(`/expired_qr?id=${props.qrId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": props.csrfToken,
        },
      });

      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 500);
    }
  }, [subStatus]);

  const handleTimerExpire = () => {
    sessionStorage.clear();
    setSubmitTrigger((prev) => !prev);
    window.location.href = "/expired_qr?id=" + props.qrId;
  };

  return (
    <div style={{ minHeight: "86vh" }}>
      <div className="guided-questionnaire-container">
        {subStatus != "thankYou" && (
          <IdleCheckModal onExpire={handleTimerExpire} />
        )}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            container
            direction="row"
            className="guided-questionnaire-container-inner"
          >
            <div className="guided-questionnaire-header-container">
              <div className="guided-questionnaire-logo-title-container">
                <img
                  src={props.logo_src}
                  alt="Project Starfield"
                  className="guided-questionnaire-logo"
                />
              </div>
              <div
                style={{
                  textAlign: "center",
                  paddingTop: 24,
                  paddingBottom: 24,
                }}
              >
                {questionnaireAssignments.length >= currentStep + 1 && (
                  <p
                    style={{
                      font: "20px QuicksandMedium",
                      fontWeight: "bold",
                      color: "#1e1e1e",
                    }}
                  >
                    {`${questionnaireAssignment?.questionnaire_name} (${
                      currentStep + 1
                    }/${questionnaireAssignments.length})`}
                  </p>
                )}

                {questionnaireAssignments.length < currentStep + 1 && (
                  <p
                    style={{
                      font: "20px QuicksandMedium",
                      fontWeight: "bold",
                      color: "#1e1e1e",
                    }}
                  >
                    Response Received
                  </p>
                )}
              </div>
            </div>
            <div className="guided-questionnaire-divider"></div>
            <div className="guided-questionnaire-content-container">
              <div
                className="guided-questionnaire-content-description-container"
                style={{ paddingBottom: "15px" }}
              >
                {questionnaireAssignments.length >= currentStep + 1 && (
                  <p className="guided-questionnaire-content-description-text">
                    Please enter the information below.
                  </p>
                )}
              </div>
              <Grid
                container
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "10px 24px",
                }}
              >
                {subStatus == "thankYou" &&
                  questionnaireAssignments.length < currentStep + 1 && (
                    <ThankYouContent>
                      <Grid
                        item
                        xs={12}
                        md={6}
                        className="q-submission-container text-center"
                        style={{ height: "90vh", lineHeight: "1.7" }}
                      >
                        Your response has been recorded. Your provider will
                        review your
                        <br />
                        results soon. Please return this tablet to the reception
                        desk.
                        <p>Thank you.</p>
                      </Grid>
                    </ThankYouContent>
                  )}
                <Grid
                  item
                  xs={12}
                  md={6}
                  style={{
                    background: "white",
                    minHeight: "120vh",
                  }}
                >
                  {questionnaireAssignments.length >= currentStep + 1 && (
                    <QuestionnaireSubmissionForm
                      questionnaireAssignment={questionnaireAssignment}
                      setSubStatus={setSubStatus}
                      setCurrentStep={setCurrentStep}
                      userId={userId}
                      submitTrigger={submitTrigger} //triggers a submit
                      resetSubmitTrigger={() => setSubmitTrigger(false)}
                      submitText={"Submit Answers and Continue"}
                      fromTablet={true}
                    />
                  )}
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

const ThankYouContent = ({ children }) => {
  sessionStorage.clear();
  window.scrollTo(0, 0);
  return <>{children}</>;
};

export default TabletQuestionnaire;
